import type { PostResponse, StreamContent } from "@/lib/humhub-api/types";

export const buildExistingPostPayload = (post: PostResponse): StreamContent => {
  return {
    id: post.content.id,
    metadata: post.content.metadata,
    model_attributes: {
      message: post.message || "",
      url: null,
    },
    comments: post.content.comments,
    reactions: post.content.reactions,
    likes: post.content.likes || { total: 0 },
    files: post.content.files || [],
    topics: post.content.topics || [],
    user_marked_readlater: post.user_marked_readlater,
  };
};
